// removed by extract-text-webpack-plugin
module.exports = {"block":"MainMenu__block-2FVj5","visible":"MainMenu__visible-2wP7v","innerWrapper":"MainMenu__innerWrapper-3LiDH","overlay":"MainMenu__overlay-3Ao81"};